export enum RoutePath {
  WELCOME = '/welcome',
  LOGIN = '/login',
  CHANGE_PASSWORD = '/change-password',
  FORGOT_PASSWORD = '/forgot-password',
}
